import "./Affiliates.module.css";
import Header from "@/reusable_sections/Header";
import Affiliatehero from "./sections/Affiliatehero";
import Partnerbenefitsgrid from "./sections/Partnerbenefitsgrid";
import Tiers from "./sections/Tiers";
import Highimpactcommandcta from "./sections/Highimpactcommandcta";
import Footer from "@/reusable_sections/Footer";
export default function AffiliatesPage() {
  return <div>
      <Header />
      <Affiliatehero />
      <Partnerbenefitsgrid />
      <Tiers />
      <Highimpactcommandcta />
      <Footer />
    </div>;
}